import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=080cecd2&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderItems.vue?vue&type=style&index=0&id=080cecd2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080cecd2')) {
      api.createRecord('080cecd2', component.options)
    } else {
      api.reload('080cecd2', component.options)
    }
    module.hot.accept("./OrderItems.vue?vue&type=template&id=080cecd2&", function () {
      api.rerender('080cecd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/OrderItems.vue"
export default component.exports